import React, { useState, useEffect } from "react";
import { Button } from "antd";
import CustomizationService from "../../../services/CustomizationService";
import { Check, X } from "react-feather";

function PriceCard({ data, selectedTab, isLastOne, onChoosePlan }) {
  const {
    name,
    monthly_price,
    annual_price,
    available_features,
    unavailable_features,
  } = data;
  return (
    <div
      className="price-card-container"
      style={{ borderColor: isLastOne ? "#cb324c" : "#000000" }}
    >
      {isLastOne && <div className="popuplar-plan">MOST POPULAR</div>}

      <div
        className="mb-1"
        style={{ fontSize: 24, fontWeight: 700, color: "#C32340" }}
      >
        {name}
      </div>
      <div className="mb-1">
        <span style={{ fontSize: 26, fontWeight: 900 }}>
          ${selectedTab === "Month" ? monthly_price : annual_price}
        </span>
        /<span>{selectedTab.toString()}</span>
      </div>
      {available_features?.split(",").map((item) => (
        <div
          className="d-flex items-center"
          style={{ paddingTop: 5, paddingBottom: 5 }}
        >
          <Check className="mr-1" />
          {item}
        </div>
      ))}
      {unavailable_features?.split(",").map((item) => (
        <div
          className="d-flex items-center"
          style={{ paddingTop: 5, paddingBottom: 5 }}
        >
          <X className="mr-1" />
          {item}
        </div>
      ))}
      <div>
        <Button
          type="primary"
          className="custom-btn mt-2"
          onClick={() => onChoosePlan()}
        >
          Choose plan
        </Button>
      </div>
    </div>
  );
}
export default function PriceTier({ selectedTab, onChoosePlan }) {
  const [priceTierData, setPriceTierData] = useState();

  useEffect(() => {
    getPriceTier();
  }, []);

  const getPriceTier = async () => {
    const priceTier = await CustomizationService.getPriceTiers();
    setPriceTierData(priceTier?.data || []);
  };
  return (
    <div className="price-tier-container">
      <div className="grid-container">
        {priceTierData?.map((item, index) => (
          <PriceCard
            data={item}
            key={item.id}
            selectedTab={selectedTab}
            onChoosePlan={onChoosePlan}
            isLastOne={priceTierData?.length === index + 1}
          />
        ))}
      </div>
    </div>
  );
}
